var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2506_8934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.85156 15.2036V16.9669C3.85156 17.4346 4.03734 17.8831 4.36803 18.2138C4.69871 18.5445 5.14722 18.7303 5.61489 18.7303H16.1948C16.6625 18.7303 17.111 18.5445 17.4417 18.2138C17.7724 17.8831 17.9581 17.4346 17.9581 16.9669V15.2036",
    stroke: "#2177FE",
    strokeWidth: 1.98374,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49658 9.91357L10.9049 14.3219L15.3132 9.91357",
    stroke: "#2177FE",
    strokeWidth: 1.98374,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9053 3.74219V14.3221",
    stroke: "#2177FE",
    strokeWidth: 1.98374,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2506_8934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1599,
    height: 21.1599,
    fill: "white",
    transform: "translate(0.325195 0.215332)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame5);
export default __webpack_public_path__ + "static/media/Frame (5).a7ddaf8c9625e2d8dd94c667ce0eef7a.svg";
export { ForwardRef as ReactComponent };